import type { Theme } from "@mui/material";
import StatusChip from "@entrilia/shared/components/StatusChip";
import type { IntegrationAppStatus } from "../../api/types/clientTypes";

interface Props {
  appStatus: IntegrationAppStatus;
}

const getStatusProps = (
  appStatus: IntegrationAppStatus
): { statusText: string; statusColor: (theme: Theme) => string } => {
  switch (appStatus) {
    case "Published":
      return { statusText: "Connected", statusColor: (t) => t.palette.success.main };
    case "NotConfigured":
      return { statusText: "Not configured", statusColor: (t) => t.palette.warning.main };
    case "Error":
      return { statusText: "Error", statusColor: (t) => t.palette.error.main };
    case "Paused":
      return { statusText: "Paused", statusColor: (t) => t.palette.warning.main };
    case "Announced":
      return { statusText: "Coming soon", statusColor: (t) => t.palette.text.secondary };
    default:
      return { statusText: "Not connected", statusColor: (t) => t.palette.text.secondary };
  }
};

const ApplicationStatusTag = ({ appStatus }: Props) => {
  if (appStatus === "NoStatus") {
    return null;
  }

  const { statusText, statusColor } = getStatusProps(appStatus);
  return <StatusChip label={statusText} color={statusColor} />;
};

export default ApplicationStatusTag;
